import { render } from "./VestingScheduleV2.08.vue?vue&type=template&id=279984ba&scoped=true"
import script from "./VestingScheduleV2.08.vue?vue&type=script&lang=js"
export * from "./VestingScheduleV2.08.vue?vue&type=script&lang=js"

import "./VestingScheduleV2.08.vue?vue&type=style&index=0&id=279984ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279984ba"]])

export default __exports__